export default __webpack_public_path__ + "static/media/preview.5bf30723.png";